import React, { useState } from 'react';
import {
  Paper,
  InputBase,
  IconButton,
  Box,
  Typography,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { useLanguage } from '../contexts/LanguageContext';

/**
 * SearchBar component for serial number search
 * @param {Object} props - Component props
 * @param {Function} props.onSearch - Callback function when search is triggered
 * @param {boolean} props.disabled - Whether the search input is disabled
 */
const SearchBar = ({ onSearch, disabled = false }) => {
  const { t } = useLanguage();
  const [searchValue, setSearchValue] = useState('');

  const handleSearch = () => {
    if (searchValue.trim()) {
      onSearch(searchValue);
    }
  };

  const handleClear = () => {
    setSearchValue('');
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <Box sx={{ width: '100%', maxWidth: 600, mx: 'auto', mb: 4 }}>
      <Typography
        variant="h6"
        component="label"
        htmlFor="article-search"
        sx={{ mb: 1, display: 'block', color: 'text.secondary', textAlign: 'center' }}
      >
        {t('searchLabel')}
      </Typography>
      <Paper
        sx={{
          p: '2px 4px',
          display: 'flex',
          alignItems: 'center',
          borderRadius: 3,
          boxShadow: 2,
          bgcolor: 'background.paper',
          '&:hover': {
            boxShadow: 4,
          },
        }}
      >
        <InputBase
          id="article-search"
          sx={{ ml: 2, flex: 1, py: 1 }}
          placeholder={t('searchPlaceholder')}
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          onKeyPress={handleKeyPress}
          disabled={disabled}
          inputProps={{ 'aria-label': t('searchAriaLabel') }}
        />
        {searchValue && (
          <IconButton
            onClick={handleClear}
            sx={{ p: 1 }}
            aria-label={t('clearButton')}
            disabled={disabled}
          >
            <ClearIcon />
          </IconButton>
        )}
        <IconButton
          onClick={handleSearch}
          sx={{ p: 1 }}
          aria-label={t('searchButton')}
          disabled={disabled || !searchValue.trim()}
        >
          <SearchIcon />
        </IconButton>
      </Paper>
    </Box>
  );
};

export default SearchBar;
